import React from 'react';
import { useTranslation } from 'react-i18next';

const FamilyBusinessBuiltValues = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-white">
      <div className="bg-[#0A0A0A] w-full pt-20 md:pt-[172px] pb-[356px] px-5 sm:px-10">
        <h1 className="text-white text-[32px] leading-[40px] md:text-[60px] lg:text-[76.5px] md:leading-[70px] lg:leading-[100px] libre-baskerville max-w-[804px] mx-auto text-center">
          {t('home.family.title')}
        </h1>
      </div>
      <div className="px-5">
        <div
          className="mb-20 md:mb-[120px] max-w-[1196px] flex items-center justify-start -mt-[300px] mx-auto relative min-h-[598px] bg-cover bg-center bg-no-repeat rounded-[16px]"
          style={{
            backgroundImage: "url('/assets/family-business-values.webp')",
          }}
        >
          <p className="text-[24px] md:text-[31.7px] text-center leading-[30px] md:leading-[50.69px] font-normal libre-baskerville text-white relative z-10 max-w-[1000px] md:text-left px-[15px] md:pl-10 lg:pl-[90px] md:pr-6">
            {t('home.family.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FamilyBusinessBuiltValues;
